import { TRoutePoint, IRoutePointValue } from '../types/routePoints';

const getRoutePoint = (value: IRoutePointValue = {}): TRoutePoint => ({
  id: Math.random().toString(),
  value,
});

export default getRoutePoint;
